import {createAsyncThunk} from '@reduxjs/toolkit';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';
import {RootState} from 'common/src/redux/store';
import aiContentProjectApi from '../../../aiContentProject.api';
import {
  RemoteAiContentProject,
  RemoteAiContentVariationInputSchema,
} from '../../../aiContentProject.types';
import {setError, setProject} from '../aiContentProject.slice';

const updateAiContentProjectVariationInputSchema = createAsyncThunk<
  RemoteAiContentProject,
  {projectId: number; variationInputSchema: RemoteAiContentVariationInputSchema},
  {state: RootState}
>(
  `${BreadcrumbName.AiContentProjectPage}/updateAiContentProjectVariationInputSchema`,
  async ({projectId, variationInputSchema}, {dispatch, getState, rejectWithValue}) => {
    const state = getState();
    const currentProject = state.aiContentProjectPage?.project;

    if (!currentProject || currentProject.id !== projectId) {
      return rejectWithValue('Project not loaded');
    }

    dispatch(setError(null));

    try {
      // Update with only variationInputSchema, rest are null
      await aiContentProjectApi.updateAiContentProject({
        id: projectId,
        request: {
          name: null,
          brief: null,
          templateId: null,
          variationInputSchema,
        },
      });

      // Fetch the updated project
      const updatedProject = await aiContentProjectApi.getAiContentProjectById(
        projectId,
      );
      dispatch(setProject(updatedProject));

      return updatedProject;
    } catch (error) {
      const errorMessage =
        error instanceof Error ? error.message : 'Failed to update variation input schema';
      dispatch(setError(errorMessage));
      
      return rejectWithValue(errorMessage);
    }
  },
);

export default updateAiContentProjectVariationInputSchema;

